/**
 * @file supplier.constants.js
 * @description Constants for the supplier payment frequency and notes.
 */

/**
 * Supplier payment frequency options. The values match the ones accepted by the API.
 * @type {{value: string, label: string}[]}
 */
export const PAYMENT_FREQUENCIES = [
    { value: "prepaid", label: "Prepaid" },
    { value: "weekly", label: "Weekly" },
    { value: "biweekly", label: "Biweekly" },
    { value: "monthly", label: "Monthly" }
];

/**
 * Maximum length of the supplier notes (publicNotes) and the internal notes (internalNotes)
 * in the suppliers forms. The API accepts up to 1000 characters.
 * @type {number}
 */
export const NOTES_MAX_LENGTH = 500;
